const socket = io();
const boardId = "test";

socket.emit("join-board", boardId);

const board = document.getElementById("board");
const addBtn = document.getElementById("add");
const addTableBtn = document.getElementById("addTable");
const addGroupBtn = document.getElementById("addGroup");

// --------------------
// Generic Drag Funktion
// --------------------
function addDrag(el, isGroup = false, children = []) {
  let startX, startY, origX, origY;

  function point(e) {
    if (e.touches) return e.touches[0];
    return e;
  }

  function start(e) {
    // Menü & Buttons ignorieren
    if (e.target.closest(".menu-btn") || e.target.closest(".note-menu")) return;

    // Group nur am Hintergrund ziehen
    if (isGroup && e.target !== el) return;

    const p = point(e);
    startX = p.pageX;
    startY = p.pageY;
    origX = parseInt(el.style.left) || 0;
    origY = parseInt(el.style.top) || 0;

    // Kinder-Startpositionen merken (Group)
    if (isGroup) {
      children.forEach((id) => {
        const c = document.querySelector(`[data-id='${id}']`);
        if (!c) return;
        c.dataset.sx = parseInt(c.style.left) || 0;
        c.dataset.sy = parseInt(c.style.top) || 0;
      });
    }

    document.addEventListener("mousemove", move);
    document.addEventListener("mouseup", end);
    document.addEventListener("touchmove", move, { passive: false });
    document.addEventListener("touchend", end);
  }

  function move(e) {
    e.preventDefault();
    const p = point(e);
    const dx = p.pageX - startX;
    const dy = p.pageY - startY;

    el.style.left = origX + dx + "px";
    el.style.top = origY + dy + "px";

    if (isGroup) {
      children.forEach((id) => {
        const c = document.querySelector(`[data-id='${id}']`);
        if (!c) return;
        c.style.left = parseInt(c.dataset.sx) + dx + "px";
        c.style.top = parseInt(c.dataset.sy) + dy + "px";
      });
    }
  }

  function end() {
    document.removeEventListener("mousemove", move);
    document.removeEventListener("mouseup", end);
    document.removeEventListener("touchmove", move);
    document.removeEventListener("touchend", end);

    socket.emit("move-node", {
      boardId,
      id: el.dataset.id,
      data: {
        x: parseInt(el.style.left) || 0,
        y: parseInt(el.style.top) || 0,
      },
    });
  }

  el.addEventListener("mousedown", start);
  el.addEventListener("touchstart", start, { passive: false });
}

// --------------------
// Render Note
// --------------------
function renderNote(note) {
  const div = document.createElement("div");
  div.className = "note";
  div.dataset.id = note.id;
  div.dataset.parent = note.parent || "root";
  div.style.left = note.data.x + "px";
  div.style.top = note.data.y + "px";
  div.style.background = note.data.color || "yellow";

  // --------------------
  // Text Element (NUR das ist editierbar!)
  // --------------------
  const textEl = document.createElement("div");
  textEl.className = "note-text";
  textEl.textContent = note.data.text || "Neue Note";
  div.appendChild(textEl);

  // --------------------
  // Editieren per Doppelklick / Touch
  // --------------------
  function enableEdit() {
    textEl.contentEditable = true;
    textEl.focus();
  }

  div.addEventListener("dblclick", enableEdit);

  // Mobile Double Tap
  let lastTap = 0;
  div.addEventListener("touchend", () => {
    const now = Date.now();
    if (now - lastTap < 300) enableEdit();
    lastTap = now;
  });

  textEl.addEventListener("blur", () => {
    textEl.contentEditable = false;

    socket.emit("edit-node", {
      boardId,
      id: note.id,
      data: { text: textEl.textContent },
    });
  });

  // --------------------
  // Menü Button
  // --------------------
  const menuBtn = document.createElement("button");
  menuBtn.textContent = "⋯";
  menuBtn.className = "menu-btn";

  const menu = document.createElement("div");
  menu.className = "note-menu";

  // --------------------
  // Farben
  // --------------------
  ["yellow", "lightblue", "lightgreen", "pink"].forEach((color) => {
    const c = document.createElement("div");
    c.className = "color";
    c.style.background = color;
    c.onclick = (e) => {
      e.stopPropagation();

      div.style.background = color;

      socket.emit("edit-node", {
        boardId,
        id: note.id,
        data: { color },
      });

      menu.style.display = "none";
    };
    menu.appendChild(c);
  });

  // --------------------
  // Kopieren Button
  // --------------------
  const copyBtn = document.createElement("button");
  copyBtn.textContent = "Kopieren";

  copyBtn.onclick = (e) => {
    e.stopPropagation();

    // Text der Note kopieren
    const text = textEl.textContent;

    // Moderne Methode: Clipboard API
    navigator.clipboard
      .writeText(text)
      .then(() => {
        console.log("Text kopiert:", text);
        // Optional: kleines Feedback
        copyBtn.textContent = "✔ Kopiert";
        setTimeout(() => (copyBtn.textContent = "Kopieren"), 1000);
      })
      .catch((err) => {
        console.error("Fehler beim Kopieren:", err);
      });

    // Menü schließen
    menu.style.display = "none";
  };

  menu.appendChild(copyBtn);

  // --------------------
  // In Group verschieben
  // --------------------
  const groupMenuBtn = document.createElement("button");
  groupMenuBtn.textContent = "In Group";

  const groupMenu = document.createElement("div");
  groupMenu.className = "group-select-menu";

  document.querySelectorAll(".group").forEach((g) => {
    const opt = document.createElement("div");
    opt.textContent = g.dataset.id;

    opt.onclick = (e) => {
      e.stopPropagation();

      g.appendChild(div);
      div.dataset.parent = g.dataset.id;

      socket.emit("edit-node", {
        boardId,
        id: note.id,
        data: { parent: g.dataset.id },
      });

      groupMenu.style.display = "none";
    };

    groupMenu.appendChild(opt);
  });

  groupMenuBtn.onclick = (e) => {
    e.stopPropagation();
    groupMenu.style.display =
      groupMenu.style.display === "block" ? "none" : "block";
  };

  menu.appendChild(groupMenuBtn);
  menu.appendChild(groupMenu);

  // --------------------
  // Löschen
  // --------------------
  const del = document.createElement("button");
  del.textContent = "Löschen";

  del.onclick = () => {
    socket.emit("delete-node", { boardId, id: note.id });
    div.remove();
  };

  menu.appendChild(del);

  menuBtn.onclick = (e) => {
    e.stopPropagation();
    menu.style.display = menu.style.display === "block" ? "none" : "block";
  };

  document.addEventListener("click", () => {
    menu.style.display = "none";
    groupMenu.style.display = "none";
  });

  div.appendChild(menuBtn);
  div.appendChild(menu);

  board.appendChild(div);

  addDrag(div);
}

// --------------------
// Render Table
// --------------------
function renderTable(node, isUpdate = false) {
  const tableData = node.data;
  let div = document.querySelector(`[data-id='${node.id}']`);

  if (!div) {
    // NEUE Tabelle
    div = document.createElement("div");
    div.className = "table";
    div.dataset.id = node.id;
    div.dataset.parent = node.parent || "root";
    div.style.left = tableData.x + "px";
    div.style.top = tableData.y + "px";
    div.nodeData = tableData;
    const parentEl =
      node.parent && node.parent !== "root"
        ? document.querySelector(`[data-id='${node.parent}']`)
        : board;
    parentEl.appendChild(div);
    addDrag(div);
  } else {
    // Update: nur nodeData überschreiben, alten Table löschen
    div.nodeData = tableData;
    const oldTbl = div.querySelector("table");
    if (oldTbl) oldTbl.remove();
  }

  const tbl = document.createElement("table");

  // ===============================
  // HEADER ROW
  // ===============================
  const headerTr = document.createElement("tr");
  tableData.cells[0].forEach((_, c) => {
    const th = document.createElement("th");
    th.textContent = String.fromCharCode(65 + c);
    th.style.background = tableData.cells[0][c].color || "#ddd";
    headerTr.appendChild(th);
  });
  tbl.appendChild(headerTr);

  // ===============================
  // BODY
  // ===============================
  // Body Rows
  tableData.cells.forEach((row, r) => {
    const tr = document.createElement("tr");
    row.forEach((cell, c) => {
      const td = document.createElement("td");
      td.contentEditable = true;
      td.textContent = cell.value ?? "";
      td.style.background = cell.color || "#fff";

      td.addEventListener("input", () => {
        socket.emit("edit-node", {
          boardId: node.boardId,
          id: node.id,
          data: { cell: { r, c, value: td.textContent } },
        });
      });

      td.addEventListener("contextmenu", (e) => {
        e.preventDefault();
        if (c === 0 || c === row.length - 1 || r === 0) {
          const picker = document.createElement("input");
          picker.type = "color";
          picker.value = cell.color || "#ffffff";
          picker.oninput = () => {
            td.style.background = picker.value;
            socket.emit("edit-node", {
              boardId: node.boardId,
              id: node.id,
              data: { cell: { r, c, color: picker.value } },
            });
          };
          picker.click();
        }
      });

      tr.appendChild(td);
    });
    tbl.appendChild(tr);
  });

  // **Nur einmal anhängen**
  div.append(tbl);

  // ===============================
  // MENU
  // ===============================
  const menuBtn = document.createElement("button");
  menuBtn.textContent = "⋯";
  menuBtn.className = "menu-btn";

  const menu = document.createElement("div");
  menu.className = "note-menu";

  const addRow = document.createElement("button");
  addRow.textContent = "Zeile +";
  addRow.onclick = () =>
    socket.emit("edit-node", {
      boardId: node.boardId,
      id: node.id,
      data: { addRow: true },
    });

  const delRow = document.createElement("button");
  delRow.textContent = "Zeile -";
  delRow.onclick = () =>
    socket.emit("edit-node", {
      boardId: node.boardId,
      id: node.id,
      data: { removeRow: true },
    });

  const addCol = document.createElement("button");
  addCol.textContent = "Spalte +";
  addCol.onclick = () =>
    socket.emit("edit-node", {
      boardId: node.boardId,
      id: node.id,
      data: { addColAfter: tableData.cells[0].length - 1 },
    });

  const delCol = document.createElement("button");
  delCol.textContent = "Spalte -";
  delCol.onclick = () =>
    socket.emit("edit-node", {
      boardId: node.boardId,
      id: node.id,
      data: { removeCol: tableData.cells[0].length - 1 },
    });

  // Farben
  const colorLeft = document.createElement("input");
  colorLeft.type = "color";
  colorLeft.oninput = () =>
    socket.emit("edit-node", {
      boardId: node.boardId,
      id: node.id,
      data: { colorCol: { c: 0, color: colorLeft.value } },
    });

  const colorRight = document.createElement("input");
  colorRight.type = "color";
  colorRight.oninput = () =>
    socket.emit("edit-node", {
      boardId: node.boardId,
      id: node.id,
      data: {
        colorCol: { c: tableData.cells[0].length - 1, color: colorRight.value },
      },
    });

  const colorTop = document.createElement("input");
  colorTop.type = "color";
  colorTop.oninput = () =>
    tableData.cells[0].forEach((_, c) =>
      socket.emit("edit-node", {
        boardId: node.boardId,
        id: node.id,
        data: { cell: { r: 0, c, color: colorTop.value } },
      }),
    );

  const groupBtn = document.createElement("button");
  groupBtn.textContent = "In Group";

  const groupMenu = document.createElement("div");
  groupMenu.className = "group-select-menu";
  document.querySelectorAll(".group").forEach((g) => {
    const opt = document.createElement("div");
    opt.textContent = g.dataset.id;
    opt.onclick = (e) => {
      e.stopPropagation();
      g.appendChild(div);
      div.dataset.parent = g.dataset.id;
      socket.emit("edit-node", {
        boardId: node.boardId,
        id: node.id,
        data: { parent: g.dataset.id },
      });
      groupMenu.style.display = "none";
    };
    groupMenu.appendChild(opt);
  });

  groupBtn.onclick = (e) => {
    e.stopPropagation();
    groupMenu.style.display =
      groupMenu.style.display === "block" ? "none" : "block";
  };

  const delBtn = document.createElement("button");
  delBtn.textContent = "Löschen";
  delBtn.onclick = () => {
    socket.emit("delete-node", { boardId: node.boardId, id: node.id });
    div.remove();
  };

  menu.append(
    addRow,
    delRow,
    addCol,
    delCol,
    colorLeft,
    colorRight,
    colorTop,
    groupBtn,
    groupMenu,
    delBtn,
  );

  menuBtn.onclick = (e) => {
    e.stopPropagation();
    menu.style.display = menu.style.display === "block" ? "none" : "block";
  };

  div.append(menuBtn, menu, tbl);

  // Nur appenden, wenn neu
  if (isNew) {
    const parentEl =
      node.parent && node.parent !== "root"
        ? document.querySelector(`[data-id='${node.parent}']`)
        : board;
    parentEl.appendChild(div);
    addDrag(div);
  }
}

document.addEventListener("click", () => {
  document
    .querySelectorAll(".note-menu, .group-select-menu, .col-menu")
    .forEach((m) => (m.style.display = "none"));
});

// --------------------
// Render Group
// --------------------
function renderGroup(group) {
  const div = document.createElement("div");
  div.className = "group";
  div.dataset.id = group.id;
  div.style.left = group.data.x + "px";
  div.style.top = group.data.y + "px";
  div.style.width = (group.data.width || 300) + "px";
  div.style.height = (group.data.height || 200) + "px";
  div.style.position = "absolute";
  div.style.border = "2px dashed #666";
  div.style.padding = "10px";
  div.style.background = "rgba(200,200,200,0.1)";
  div.style.zIndex = 0;

  board.appendChild(div); // zuerst Group ins DOM, sonst offsetLeft nicht korrekt

  // Kinder rendern / verschieben
  group.data.children.forEach((childId) => {
    const childNode = document.querySelector(`[data-id='${childId}']`);
    if (!childNode) return;

    // Aktuelle absolute Position relativ zur Group setzen
    const childX = parseInt(childNode.style.left) - group.data.x;
    const childY = parseInt(childNode.style.top) - group.data.y;

    childNode.style.left = childX + "px";
    childNode.style.top = childY + "px";
    childNode.style.position = "absolute";

    div.appendChild(childNode); // in Group verschieben
  });

  // Drag-Funktion: verschiebt Group + Kinder relativ korrekt
  addDrag(div, true, group.data.children);
}

// --------------------
// Dispatcher
// --------------------
function renderNode(node) {
  if (node.type === "note") renderNote(node);
  else if (node.type === "table") renderTable(node);
  else if (node.type === "group") renderGroup(node);
}

// --------------------
// Socket Events
// --------------------
socket.on("board-state", (state) => {
  Object.values(state.nodes).forEach(renderNode);
});

socket.on("node-created", renderNode);

// node edited
socket.on("node-edited", ({ id, data }) => {
  const div = document.querySelector(`[data-id='${id}']`);
  if (!div) return;

  // Notes
  if (div.classList.contains("note")) {
    if (data.text !== undefined)
      div.querySelector(".note-text").textContent = data.text;
    if (data.color) div.style.background = data.color;
    return;
  }

  // Tables
  if (div.classList.contains("table")) {
    let nodeData = div.nodeData;

    // Einzelne Zelle updaten
    if (data.cell) {
      const { r, c, value, color } = data.cell;
      nodeData.cells[r][c] = {
        ...nodeData.cells[r][c],
        ...(value !== undefined && { value }),
        ...(color && { color }),
      };
    }

    // Spaltenfarbe
    if (data.colorCol) {
      const { c, color } = data.colorCol;
      nodeData.cells.forEach((row) => (row[c] = { ...row[c], color }));
    }

    // Add / Remove Row
    if (data.addRow) {
      const cols = nodeData.cells[0].length;
      nodeData.cells.push(
        Array.from({ length: cols }, () => ({ value: "", color: "#fff" })),
      );
    }
    if (data.removeRow && nodeData.cells.length > 1) {
      nodeData.cells.pop();
    }

    // Add / Remove Column
    if (data.addColAfter !== undefined) {
      nodeData.cells.forEach((row) =>
        row.splice(data.addColAfter + 1, 0, { value: "", color: "#fff" }),
      );
    }
    if (data.removeCol !== undefined && nodeData.cells[0].length > 1) {
      nodeData.cells.forEach((row) => row.splice(data.removeCol, 1));
    }

    // nodeData speichern
    div.nodeData = nodeData;

    // Alten Table entfernen
    const oldTbl = div.querySelector("table");
    if (oldTbl) oldTbl.remove();

    // Neuen Table rendern (DIV bleibt bestehen!)
    const tableNode = {
      id,
      parent: div.dataset.parent,
      boardId,
      type: "table",
      data: nodeData,
    };
    renderTable(tableNode, true); // <--- wir brauchen hier ein Flag "isUpdate"
  }
});

socket.on("node-moved", ({ id, data }) => {
  const el = document.querySelector(`[data-id='${id}']`);
  if (!el) return;
  el.style.left = data.x + "px";
  el.style.top = data.y + "px";
});

socket.on("node-deleted", ({ id }) => {
  document.querySelector(`[data-id='${id}']`)?.remove();
});

// --------------------
// Add Note / Table / Group Buttons
// --------------------
addBtn.onclick = () => {
  const note = {
    boardId,
    id: "note-" + Date.now(),
    type: "note",
    parent: "root",
    data: { x: 50, y: 50, text: "Neue Note", color: "yellow" },
  };
  socket.emit("create-node", note);
  renderNode(note);
};

// --------------------
// Add Table Button
// --------------------
addTableBtn.onclick = () => {
  const rows = 8;
  const cols = 8;
  const cells = Array.from({ length: rows }, () =>
    Array.from({ length: cols }, () => ({ value: "", color: "#fff" })),
  );

  const table = {
    boardId,
    id: "table-" + Date.now(),
    type: "table",
    parent: "root",
    data: {
      x: 200,
      y: 200,
      rows,
      cols,
      cells,
    },
  };
  socket.emit("create-node", table);
  renderNode(table);
};

function enableNoteEdit(div, id) {
  div.contentEditable = true;
  div.focus();

  function finish() {
    div.contentEditable = false;
    socket.emit("edit-note", {
      boardId,
      id,
      data: { text: div.textContent },
    });
    div.removeEventListener("blur", finish);
  }

  div.addEventListener("blur", finish);
}

addGroupBtn.onclick = () => {
  const group = {
    boardId,
    id: "group-" + Date.now(),
    type: "group",
    parent: "root",
    data: { x: 100, y: 100, width: 400, height: 300, children: [] },
  };
  socket.emit("create-node", group);
  renderNode(group);
};
